import type { LucideIcon } from 'lucide-react';
import { X } from 'lucide-react';

export function SelectionBar({
	count,
	actions,
	onClear,
}: {
	count: number;
	actions: Array<{
		label: string;
		icon: LucideIcon;
		onClick: () => void;
	}>;
	onClear: () => void;
}) {
	if (count === 0) return null;

	return (
		<div className="pointer-events-none fixed inset-x-4 bottom-6 z-50 flex justify-center sm:inset-x-0">
			<div className="pointer-events-auto flex items-center gap-1 rounded-xl border border-line-2 bg-surface px-2 py-1.5 shadow-[var(--elev-bar)]">
				<div className="flex items-center gap-2 px-2.5">
					<span className="flex h-5 min-w-5 items-center justify-center rounded-md bg-accent px-1.5 font-mono text-xs leading-none font-semibold text-accent-fg">
						{count}
					</span>
					<span className="hidden text-sm whitespace-nowrap text-text-1 sm:inline">
						{count === 1 ? '1 selected' : `${count} selected`}
					</span>
				</div>

				<div className="h-5 w-px bg-line-2" />

				{actions.map((action) => (
					<div key={action.label} className="group/tip relative">
						<button
							onClick={action.onClick}
							className="flex h-8 cursor-pointer items-center gap-1.5 rounded-lg px-2 text-sm text-text-2 transition-colors hover:bg-surface-hover hover:text-text-1 sm:px-3"
						>
							<action.icon size={14} className="shrink-0" />
							<span className="hidden sm:inline">{action.label}</span>
						</button>
						<span className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded-md bg-foreground px-2.5 py-1 text-xs text-background opacity-0 transition-opacity group-hover/tip:opacity-100 sm:hidden">
							{action.label}
						</span>
					</div>
				))}

				<div className="h-5 w-px bg-line-2" />

				<button
					onClick={onClear}
					className="flex h-7 w-7 cursor-pointer items-center justify-center rounded-lg text-text-3 transition-colors hover:bg-surface-hover hover:text-text-1"
				>
					<X size={14} />
				</button>
			</div>
		</div>
	);
}
